import { useState } from 'react';
import './styles/App.css';
import { ToastContainer, toast } from 'react-toastify';
import { FaRegCopy } from "react-icons/fa6";
import { ImRadioChecked2 } from "react-icons/im";
import { CircleCheckBig } from 'lucide-react';

const Books = ({ passedMaxPassages }) => {

    const [isContentOneVisible, setIsContentOneVisible] = useState(true);

    const abbreviations = [
        "Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy", "Joshua", "Judges", "Ruth", 
        "1 Samuel", "2 Samuel", "1 Kings", "2 Kings", "1 Chronicles", "2 Chronicles", "Ezra", "Nehemiah", 
        "Esther", "Job", "Psalms", "Proverbs", "Ecclesiastes", "Song of Songs", "Isaiah", "Jeremiah", 
        "Lamentations", "Ezekiel", "Daniel", "Hosea", "Joel", "Amos", "Obadiah", "Jonah", "Micah", "Nahum", 
        "Habakkuk", "Zephaniah", "Haggai", "Zechariah", "Malachi", "Matthew", "Mark", "Luke", "John", 
        "Acts", "Romans", "1 Corinthians", "2 Corinthians", "Galatians", "Ephesians", "Philippians", "Colossians", 
        "1 Thessalonians", "2 Thessalonians", "1 Timothy", "2 Timothy", "Titus", "Philemon", "Hebrews", "James", 
        "1 Peter", "2 Peter", "1 John", "2 John", "3 John", "Jude", "Revelation"
    ];

    const thirdIndex = Math.ceil(abbreviations.length / 3);
    const firstColumn = abbreviations.slice(0, thirdIndex);
    const secondColumn = abbreviations.slice(thirdIndex, thirdIndex * 2);
    const thirdColumn = abbreviations.slice(thirdIndex * 2);

    const showToast = (abbrev) => {
        toast(
            <div style={{display: 'flex', alignItems: 'center'}}>
                <CircleCheckBig style={{color: '#4f63ff', marginLeft: '2px'}}/>
                <span>Copied! {abbrev}</span>
            </div>,
            {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progressClassName: 'blue-progress',
                className: 'custom-toast',
                style: {
                    backgroundColor: 'white',
                    color: 'black',
                    fontSize: '16px',
                    padding: '2px 5px',
                    borderRadius: '5px',
                }
            }
        );
    };

    const handleCopy = (abbrev) => {
        navigator.clipboard.writeText(abbrev);
    };

    const handleClick = (abbrev) => {
        showToast(abbrev);  // Show toast notification
        handleCopy(abbrev); // Copy the book to the clipboard for pasting
    };

    return (
        <div>
           <ToastContainer />
            <div className="content">
                {isContentOneVisible ? (
                    <div className="text-box">
                       <h1>Plan Builder Instructions</h1>

                            <p className="P-format"><strong>Structuring your plan:</strong></p>

                            <p className="P" style={{paddingLeft:"10px"}}>1.  Select the plan length in days.</p>
                            <p className="P" style={{paddingLeft:"10px"}}>2.  Choose the maximum number of passages per day. Blank fields for days with fewer passages will be removed.</p>

                            <div className="h3-heading">Curating your passages </div>

                            <p className="P">For individual passages here are acceptable formats:</p>
                            
                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">Single chapters:  Genesis 1</div></div>
                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">Single verses:  Genesis 1:1</div></div> 
                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">Books with a single chapter:  Jude 1</div></div> 
                            
                             <p className="P">Consecutive passages:  For consecutive passages, here are accepted formats</p>
                             <p className="P"><strong>Each passage field supports up to three consecutive chapters</strong> (E.g., Genesis 1-3)</p>

                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">Consecutive chapters:  Genesis 1-3</div></div> 
                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">Passages spanning multiple books:  Genesis 50, Exodus 1(In separate inputs)</div></div>  
                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">A section of verses:  Genesis 1:1-10</div></div> 
                            
                             <p className="P">For days with fewer or no passages</p>

                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">Unused passages can be left blank.</div></div> 
                                <div className="bullet-line"><ImRadioChecked2 color="#808080" className="bullet"/><div className="P-M">Check "No Reading" for days without any passages.</div> </div> 

                            <div className="h3-heading">Predictive assistance:</div><p className="P">  Predictions for the next chapters or verses will appear as you build. If desired, press the Tab key to auto-fill the suggestions.</p>

                            <p className="P-format"><strong>Downloading and uploading your plan:</strong></p>

                            <p className="P" style={{paddingLeft:"10px"}}>1.  Click “Download plan” to save your plan and download the XML file. </p>
                            <p className="P" style={{paddingLeft:"10px"}}>2.  If you need help with uploading your plan click <a className="link"  href="https://support.subsplash.com/en/articles/9067478-custom-bible-reading-plans">HERE</a> for more help.</p>
                            <h3 className="pin">Also, you can pin the book title list below to quickly copy names and track added books by clicking the "book list" button below!</h3>
                            <div className="button-container">

                        <button
                            onClick={() => setIsContentOneVisible(false)} 
                            className="btn btn-primary relative-toggle"
                            tabIndex="-1"
                        >
                            Books list
                        </button>
                        </div>
                    </div>
                ) : (
                    <div className="books-container">
                        <div className="columns">

                            <div className="column">
                            {firstColumn.map((abbrev, index) => (
                                <div key={index} className="abbreviation-item">
                                <div className="abbreviation-container">
                                    <span>{abbrev}</span>
                                </div>
                                {passedMaxPassages && passedMaxPassages[abbrev] === true && (
                                    <span className="check-icon">
                                    <CircleCheckBig color="#4f63ff" className="checkforbooks" />
                                    </span>
                                )}
                                <button tabIndex="-1" onClick={() => handleClick(abbrev)} className="copy-button">
                                    <FaRegCopy />
                                </button>
                                </div>
                            ))}
                            </div>
                            <div className="column">
                            {secondColumn.map((abbrev, index) => (
                                <div key={index} className="abbreviation-item">
                                <div className="abbreviation-container">
                                    <span>{abbrev}</span>
                                </div>
                                {passedMaxPassages && passedMaxPassages[abbrev] === true && (
                                    <span className="check-icon">
                                    <CircleCheckBig color="#4f63ff" className="checkforbooks" />
                                    </span>
                                )}
                                <button tabIndex="-1" onClick={() => handleClick(abbrev)} className="copy-button">
                                    <FaRegCopy />
                                </button>
                                </div>
                            ))}
                            </div>
                            <div className="column">
                            {thirdColumn.map((abbrev, index) => (
                                <div key={index} className="abbreviation-item">
                                <div className="abbreviation-container">
                                    <span>{abbrev}</span>
                                </div>
                                {passedMaxPassages && passedMaxPassages[abbrev] === true && (
                                    <span className="check-icon">
                                    <CircleCheckBig color="#4f63ff" className="checkforbooks" />
                                    </span>
                                )}
                                <button tabIndex="-1" onClick={() => handleClick(abbrev)} className="copy-button">
                                    <FaRegCopy />
                                </button>
                                </div>
                            ))}
                            </div>
                        </div>
                        <button
                            onClick={() => setIsContentOneVisible(true)} 
                            className="btn btn-primary fixed-toggle"
                            tabIndex="-1"
                        >
                            Instructions
                        </button>
                        
                    </div>
                )}
            </div>
        </div>
    );
};

export default Books;